/**
 * Web Speech API 语音输入
 * 浏览器原生语音识别，支持 Chrome/Edge
 */

const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition

let _recognition = null

export function isSpeechSupported() {
  return !!SpeechRecognition
}

// 检测不支持的原因
export function getSpeechUnsupportedReason() {
  if (!SpeechRecognition) return '当前浏览器不支持语音识别，请使用 Chrome 或 Edge'
  if (location.protocol !== 'https:' && location.hostname !== 'localhost' && location.hostname !== '127.0.0.1') {
    return '语音识别需要 HTTPS 安全连接，当前为 HTTP 环境'
  }
  return ''
}

/**
 * 开始语音识别
 * @param {Function} onResult - (text, isFinal) => void  实时回调
 * @param {Function} onEnd - () => void  识别结束回调
 * @param {Function} onError - (error) => void  错误回调
 */
export async function startSpeechRecognition(onResult, onEnd, onError) {
  if (!SpeechRecognition) {
    if (onError) onError('浏览器不支持语音识别')
    return
  }
  // 先检测麦克风设备
  try {
    if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
      const devices = await navigator.mediaDevices.enumerateDevices()
      const hasMic = devices.some(function (d) { return d.kind === 'audioinput' && d.deviceId })
      if (!hasMic) {
        if (onError) onError('未找到麦克风设备，请插入麦克风后重试')
        return
      }
    }
  } catch (e) { /* enumerateDevices 失败不阻断，继续尝试 */ }
  // 停掉上一次
  if (_recognition) {
    try { _recognition.stop() } catch (e) { /* ignore */ }
  }

  _recognition = new SpeechRecognition()
  _recognition.lang = 'zh-CN'
  _recognition.continuous = true
  _recognition.interimResults = true

  _recognition.onresult = function (event) {
    let finalText = ''
    let interimText = ''
    for (let i = 0; i < event.results.length; i++) {
      const result = event.results[i]
      if (result.isFinal) {
        finalText += result[0].transcript
      } else {
        interimText += result[0].transcript
      }
    }
    if (onResult) onResult(finalText + interimText, !interimText)
  }

  let _hasError = false
  _recognition.onerror = function (event) {
    _hasError = true
    _recognition = null
    const errorMap = {
      'not-allowed': '麦克风权限被拒绝，请在浏览器设置中允许使用麦克风',
      'no-speech': '未检测到语音，请重试',
      'audio-capture': '未找到麦克风设备，请检查麦克风连接',
      'network': '网络错误，语音识别需要网络连接',
      'aborted': ''
    }
    const msg = errorMap[event.error] || ('语音识别失败：' + event.error)
    if (msg && onError) onError(msg)
  }

  _recognition.onend = function () {
    _recognition = null
    // 有错误时不触发 onEnd，让错误面板保持显示
    if (!_hasError && onEnd) onEnd()
  }

  try {
    _recognition.start()
  } catch (e) {
    _recognition = null
    if (onError) onError('语音识别启动失败：' + (e.message || e))
  }
}

/**
 * 停止语音识别
 */
export function stopSpeechRecognition() {
  if (_recognition) {
    try { _recognition.stop() } catch (e) { /* ignore */ }
  }
}
